const Plugin_RegistrBudov = {
    fields: [
        "ulice",
        "orientacnicislo",
        "domovnicislo",
        "obec",
        "castobce",
        "mestskacast",
        "psc",
        "posta",
        "okres",
    ],

    clearCode: function() {
        const code = $("#modal-kodadresy");
        code.val('');

        const doNotCheck = parseInt(code.data('do-not-check'));
        if (1 !== doNotCheck) {
            const buttonSave = $("#dialogButtons").find("button.btn.btn-primary");
            buttonSave.attr("disabled", true).prop("disabled", true);
        }
    },

    findAddress: function() {

        let url = window.location.protocol + "//" + window.location.host;
        url += "/plugin/PluginRegistrBudov/ajaxFindAddress";

        const modalWindow = $("[id^=\"modal-container-\"]").last();

        $.ajax({
            type: "post",
            url: url,
            data: $(modalWindow).find("form").serialize(),
            dataType: "json",
            global: false,
            beforeSend: function() {
                Lemo_Alert.closeAll();
                Lemo_Alert.addInfo("Ověřuji adresu ...", "rbSearchBeforeSend");
            },
            complete: function() {
                Lemo_Alert.closeById("rbSearchBeforeSend");
            },
            success: function(r) {

                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                if (r.hasOwnProperty("status") && true === r.status) {

                    if (r.hasOwnProperty("data")) {
                        Plugin_RegistrBudov.updateForm(r.data);
                    }

                    $("#dialogButtons").find("button.btn.btn-primary").attr("disabled", false).prop("disabled", false);
                    Lemo_Alert.closeAll();
                    Lemo_Alert.addSuccess("Adresa byla úspěšně ověřena", "rbSearchSuccess");
                }
            },
            error: function() {
                Lemo_Alert.closeAll();
                Lemo_Alert.addDanger("Ověření adresy selhalo", "rbSearchError");
            }
        });
    },

    loadAddress: function() {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/plugin/PluginZadost/ajaxLoadAddress";

        const _ch = $("#_ch");
        if (!_ch.length) {
            return;
        }

        const kod = $("#modal-kodadresy");

        $.ajax({
            type: "post",
            url: url,
            data: { "_ch": _ch.val(), "kodadresy": kod.val() },
            dataType: "json",
            global: false,
            beforeSend: function() {
                Lemo_Alert.closeAll();
                Lemo_Alert.addInfo("Načítám adresu ...", "addressLoadBeforeSend");
            },
            complete: function() {
                Lemo_Alert.closeById("addressLoadBeforeSend");
            },
            success: function(r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                if (r.hasOwnProperty("status") && true === r.status) {
                    if (r.hasOwnProperty("data")) {
                        Plugin_RegistrBudov.updateForm(r.data);
                    }

                    $("#dialogButtons").find("button.btn.btn-primary").attr("disabled", false).prop("disabled", false);
                    Lemo_Alert.addSuccess("Adresa byla úspěšně načtena", "addressLoadSuccess");
                }
            },
            error: function() {
                Lemo_Alert.addDanger("Načtení adresy selhalo", "addressLoadError");
            }
        });
    },

    updateForm: function(data) {
        if (data.hasOwnProperty("kodadresy")) {
            $("#modal-kodadresy").val(data["kodadresy"]);
        }

        $.each(Plugin_RegistrBudov.fields, function(i, field) {
            let element = $("#modal-" + field);
            if (element.length) {
                element.val(data[field]);
            }
        });
    },

    init: function() {
        const kodadresy = $("#modal-kodadresy");
        if (kodadresy.length) {
            Lemo_Modal.disableSubmitOnEnter();

            const doNotCheck = parseInt(kodadresy.data('do-not-check'));
            const buttonSave = $("#dialogButtons").find("button.btn.btn-primary");
            if ('' === kodadresy.val() && 1 !== doNotCheck) {
                buttonSave.attr("disabled", true).prop("disabled", true);
            }

            const buttonAddressCheck = $("#button-address-check");
            if (buttonAddressCheck.length) {
                buttonAddressCheck
                    .off("click")
                    .on("click", function(e) {
                        e.preventDefault();
                        buttonSave.attr("disabled", true).prop("disabled", true);
                        Plugin_RegistrBudov.findAddress();
                    });
            }

            kodadresy.on("keyup", function() {
                const codeValue = kodadresy.val();
                buttonSave.attr("disabled", true).prop("disabled", true);
                if (codeValue.length > 4) {
                    Plugin_RegistrBudov.findAddress();
                }
            });

            $.each(Plugin_RegistrBudov.fields, function(i, field) {
                let element = $("#modal-" + field);
                if (element.length) {
                    element
                        .off("keyup change")
                        .on("keyup change", function() {
                            Plugin_RegistrBudov.clearCode();
                        });
                }
            });

            const buttonAddressLoad = $("#button-address-load");
            if (buttonAddressLoad.length) {
                buttonAddressLoad
                    .off("click")
                    .on("click", function(e) {
                        e.preventDefault();
                        buttonSave.attr("disabled", true).prop("disabled", true);
                        Plugin_RegistrBudov.loadAddress();
                    });
            }
        }
    },

    initNacteniAdresyUzivatele: function() {
        const buttonAddressLoad = $("#button-address-load");
        if (buttonAddressLoad.length) {
            buttonAddressLoad
                .off("click")
                .on("click", function(e) {
                    e.preventDefault();
                    Plugin_RegistrBudov.loadAddress();
                });
        }
    }
};


$(document)
    .ready(function() {
        $(document)
            .on("modal.miniform.item.add.build modal.miniform.item.add.error", function() {
                Plugin_RegistrBudov.initNacteniAdresyUzivatele();
            })
            .on("modal.miniform.item.edit.build modal.miniform.item.edit.error", function() {
                Plugin_RegistrBudov.initNacteniAdresyUzivatele();
            });
    });



